export const locationFields = `
  location {
    title
    street
    city
    zipcode
    country
  }
`;
